module.exports = __webpack_public_path__ + "img/support-information-fill.70bf815c.svg";